import { cpBaseUrl, GET, PUT, omsBaseUrlApi, baseUrlApi } from '@constants/generic-constants';
import { ifValueExists, isDubizzleTenant } from '../utils/utils';
import NetworkManager from '../services/network-service';
import { isCP } from '../utils/app-utils';
import tenantConfig from 'data/customizer/tenant-config';

export const categoriesApi = (params = '', signal) => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/categories?f[display]=true&sort[name]=asc${params?.replace('?', '&')}`;
    NetworkManager.performRequest(url, null, GET, signal)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getS3PreSignedUrl = (attachmentType, key, fileName) => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/attachments/presigned_url?attachment_type=${attachmentType}&key=${key}&file_name=${fileName}`;
    NetworkManager.performRequest(url, null, GET)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getLocationsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/locations${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAreasApi = (params = '', three_pl_enabled = undefined) => {
  const query3PL = !!tenantConfig?.handle_self_delivery && ifValueExists(three_pl_enabled);
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/locations?f[level]=${isDubizzleTenant() ? 3 : 4}&sort[title]=asc&f[parent_id]=${params}${query3PL ? `&three_pl_enabled=${three_pl_enabled}` : ''}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCitiesApi = (params = '', delivery_locations = true, three_pl_enabled = undefined) => {
  const query3PL = !!tenantConfig?.handle_self_delivery && ifValueExists(three_pl_enabled);
  let delivery_locations_override = delivery_locations;
  if (query3PL && three_pl_enabled === false) {
    delivery_locations_override = true;
  }
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/locations?f[level]=${isDubizzleTenant() ? 2 : 3}&delivery_locations=${delivery_locations_override?.toString()}&sort[title]=asc${params.replace('?', '&')}${query3PL ? `&three_pl_enabled=${three_pl_enabled}` : ''}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTenantConigrationApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const baseUrl = isCP() ? cpBaseUrl : omsBaseUrlApi;
    let url = `${baseUrl}/tenants/current${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const fetchPaymentMethodsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/payment_methods${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAdminsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${cpBaseUrl}/admins${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const banksListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/banks?sort[name]=asc${params?.replace('?', '&')}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const fetchPayoutStatusApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/fulfillments/statuses${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getFileUrlApi = ({ id = '' }) => {
  return new Promise((resolve, reject) => {
    const url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/attachments/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getSizeUnitsApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/sizes/units${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getDeliveryChargesApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? `${cpBaseUrl}/replica/products` : `${omsBaseUrlApi}/products`}/shipping_charges_options${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const resetPasswordApi = (token, passwordData) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/auth/password?reset_password_token=${token}`;
    NetworkManager.performRequest(url, passwordData, PUT)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const clientTypesApi = (params = '') => {
  return new Promise((resolve, reject) => {
    const url = `${baseUrlApi}/public/stores/client_types${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
